import React from "react";
import { Text, View, TouchableHighlight } from "react-native";
import { EStyleSheet } from "react-native-extended-stylesheet-typescript";
import { CheckmarkIcon } from "../icons/CheckmarkIcon";
import { GlobalStyles, Transition } from "../style/Style";

export interface BespokePropProps {
    propString: string;
    isSelected: boolean;
    index: number;
    disabled?: boolean;
    onSelect: (index: number) => void;
    isLast: boolean;
}

export const BespokeProp = ({
    propString,
    isSelected,
    index,
    disabled,
    onSelect,
    isLast,
}: BespokePropProps): JSX.Element => {
    const styles = GenerateSelectionContainerStyles(isSelected);

    return (
        <TouchableHighlight
            underlayColor="none"
            style={[styles.prop, isLast && styles.lastProp, Transition()]}
            disabled={disabled}
            onPress={() => {
                onSelect(index);
            }}
        >
            <>
                <View style={[styles.outerContainer, styles.background, Transition()]}>
                    <View style={[styles.innerOutline, Transition()]}>
                        <Text style={styles.answer}>{propString}</Text>
                    </View>
                </View>
                <View style={styles.icon}>
                    {!disabled &&
                        (isSelected ? (
                            <CheckmarkIcon fill={EStyleSheet.value(GlobalStyles.PROP_SELECTED_ICON)} />
                        ) : (
                            <View style={styles.optionIcon} />
                        ))}
                </View>
            </>
        </TouchableHighlight>
    );
};

const GenerateSelectionContainerStyles = (isSelected: boolean) =>
    EStyleSheet.create({
        prop: {
            width: "100%",
            minHeight: 30,
            marginBottom: 5,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
        },
        lastProp: {
            marginBottom: 0,
        },
        outerContainer: {
            flex: 1,
            minHeight: 30,
            borderTopLeftRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            borderBottomLeftRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            justifyContent: "center",
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: isSelected ? () => EStyleSheet.value(GlobalStyles.PROP_SELECTED) : "transparent",
        },
        innerOutline: {
            flex: 1,
            borderTopLeftRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            borderBottomLeftRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            paddingHorizontal: 10,
            minHeight: 26,
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: isSelected ? () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR) : "transparent",
            justifyContent: "center",
        },
        background: {
            backgroundColor: isSelected
                ? () => EStyleSheet.value(GlobalStyles.PROP_SELECTED_BACKGROUND)
                : () => EStyleSheet.value(GlobalStyles.PROP_BACKGROUND),
        },
        answer: {
            width: "100%",
            color: isSelected
                ? () => EStyleSheet.value(GlobalStyles.PROP_SELECTED_TEXT)
                : () => EStyleSheet.value(GlobalStyles.PROP_TEXT),
            fontSize: 14,
            lineHeight: 18,
            fontWeight: "600",
        },
        odd: {
            color: isSelected
                ? () => EStyleSheet.value(GlobalStyles.PROP_SELECTED_TEXT)
                : () => EStyleSheet.value(GlobalStyles.PROP_TEXT),
            fontSize: 16,
            lineHeight: 16,
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
        icon: {
            width: 46,
            height: "100%",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            borderTopRightRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            borderBottomRightRadius: () => EStyleSheet.value(GlobalStyles.PROP_BORDER_RADIUS),
            backgroundColor: isSelected
                ? () => EStyleSheet.value(GlobalStyles.PROP_SELECTED)
                : () => EStyleSheet.value(GlobalStyles.PROP_BACKGROUND),
        },
        optionIcon: {
            width: 16,
            height: 16,
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: () => EStyleSheet.value(GlobalStyles.PROP_ICON),
            borderRadius: "100%",
        },
    });
